<agr-page-toolbar
  [isEmpty]="(cycle$ | async)?.orders.length === 0"
  [emptyTitle]="'order.no-orders-title' | translate"
  [emptyDescription]="'order.no-orders-description' | translate"
  emptyImage="assets/images/arrival.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="addDialog()"
  data-test="order-overview"
>
  <ng-container *ngIf="(isLoading$ | async) === false && cycle$ | async as cycle">
    <mat-nav-list role="list" *ngIf="cycle?.orders?.length" class="order-overview__list">
      <a
        mat-list-item
        *ngFor="let order of sort(cycle.orders)"
        role="listitem"
        class="order-item"
        [attr.data-test]="'order-overview__item_' + order.id"
        (click)="openOrderEdit(order.id)"
      >
        <mat-icon matListItemIcon matListItemAvatar>assignment</mat-icon>
        <div matListItemTitle>{{ order?.propagationCompany?.name }}</div>
        <div matListItemLine class="text--gray">
          <span *ngIf="order.numberOfFemales"
            >{{ order.numberOfFemales | agrNumber }} {{ 'Female' | translate | lowercase }}</span
          >
          <span *ngIf="order.numberOfMales && order.numberOfFemales"> | </span>
          <span *ngIf="order.numberOfMales"
            >{{ order.numberOfMales | agrNumber }} {{ 'Male' | translate | lowercase }}</span
          >
          ({{ order.breed?.name }})
        </div>
        <div matListItemLine class="text--gray" *ngIf="order.arrivalDate">
          <span>{{ order.arrivalDate | date }}</span>
        </div>
        <button
          matListItemMeta
          mat-icon-button
          (click)="delete($event, order)"
          data-test="order-overview__delete-item"
        >
          <mat-icon iconPositionEnd>delete</mat-icon>
        </button>
      </a>
      <mat-divider *ngIf="cycle.orders.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
